export default "__VITE_ASSET__071d0f8e__"